import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Roles Redux States
import {
  GET_ROLES,
  GET_ROLE,
  CREATE_ROLE,
  EDIT_ROLE,
  DELETE_ROLE,
} from "./actionTypes";
import {
  setRoles,
  apiError,
  setRole,
  createRoleSuccess,
  editRoleSuccess,
  deleteRoleSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getRoles({ payload: { page, qnt, name, description, type } }) {
  try {
    const response = yield call(
      axios.get,
      `/role?${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (description ? `&description=${description}` : "") +
        (type ? `&type=${type}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setRoles(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createRole({ payload: { newRoleValues } }) {
  try {
    const response = yield call(axios.post, `/role`, newRoleValues);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(createRoleSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getRole({ payload: { idRole, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/role?${
        (idRole ? `&id=${idRole}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setRole(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editRole({ payload: { idRole, newRoleValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/role?${idRole ? `&id=${idRole}` : ""}`,
      newRoleValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editRoleSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteRole({ payload: { idRole } }) {
  try {
    const response = yield call(
      axios.delete,
      `/role?${idRole ? `&id=${idRole}` : ""}`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteRoleSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchRole() {
  yield takeEvery(GET_ROLES, getRoles);
}
export function* watchGetRole() {
  yield takeEvery(GET_ROLE, getRole);
}
export function* watchCreateRole() {
  yield takeEvery(CREATE_ROLE, createRole);
}
export function* watchEditRole() {
  yield takeEvery(EDIT_ROLE, editRole);
}
export function* watchDeleteRole() {
  yield takeEvery(DELETE_ROLE, deleteRole);
}
function* authSaga() {
  yield all([
    fork(watchRole),
    fork(watchCreateRole),
    fork(watchGetRole),
    fork(watchEditRole),
    fork(watchDeleteRole),
  ]);
}

export default authSaga;
